<div class="flex flex-col items-start checkbox-container w-[fit-content]">
  <label class="gap-[0.5em] clickable"
    [ngClass]="isContentLeft ? 'flex flex-row items-center justify-start': 'flex flex-row items-center justify-center'"
    [class.disabled]="disabled">
    <input
      data-qa="checkbox-input"
      class="checkbox-input clickable"
      type="checkbox"
      [disabled]="disabled"
      [ngModel]="checked"
      (ngModelChange)="onModelChange($event)"
    />
    <!-- '-checked' change svg file name
         'checkbox-styling;' , 'disabled;' and  'checked;' are css styles in checkbox.scss -->
    <app-all-icons
      [iconNameAndStyling]="'checkbox' + (minus ? '-minus' : checked ? '-checked' : disabled ? '-disabled' : '') + '.svg;' + checkBoxStyle + ' checkbox-styling;' + (checked ? 'checked;' : '') + (disabled ? 'disabled;' : '')"
    />
    <ng-content></ng-content>
    @if (suffixImgAndStyling) {
      <app-all-icons [iconNameAndStyling]="suffixImgAndStyling"/>
    }
  </label>
  @if (bottomDescription) {
    <div class="pl-[1.5rem] font-3 black-9">{{bottomDescription}}</div>
  }
</div>
